import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appEnterFocus]'
})
export class EnterFocusDirective {
 @Input('enterFocus') nextElement!: ElementRef;

  constructor(private el: ElementRef) {}

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    if (this.nextElement) {
      this.nextElement.nativeElement.focus();
      event.preventDefault(); // prevent default enter behavior
    }
  }
}
